import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'minutes'
})
// The work of the pipe is handled in the tranform method with our pipe's class
export class Minutes implements PipeTransform {
  transform(value: number, args: any[]) {
    let result = String(value / 60)
    return parseInt(result)
  }
}
